import { action, observable } from "mobx";
export class State {
  constructor(value) {
    this.value = value | {};
  }

  @observable loading = false;
  @observable error = null;
  @observable valid = null;
  @observable value = {};
  lock = false;

  @action async trigger(cb, { onSuccess, onError, clearonError } = {}) {
    this.error = null;
    this.loading = true;
    try {
      this.value = await cb();
      if (onSuccess) {
        onSuccess(this.value);
      }
    } catch (error) {
      this.error = error;
      if (clearonError) this.value = {};
      if (onError) onError(error);
    } finally {
      this.loading = false;
      // this.lock = false;
    }
  }
}
